<ion-app>
  <ion-split-pane contentId="main-content" [disabled]="!auth.isAuthenticated()">
    @if (auth.isAuthenticated()) {
      <ion-menu contentId="main-content" type="overlay">
        <ion-content>
        <div class="menu-brand-header">
          <div class="menu-logo-icon">
            <ion-icon name="server-outline"></ion-icon>
          </div>
          <div class="menu-brand-text">
            <h2>ustat</h2>
            <span>Hızlı Ön Muhasebe</span>
          </div>
        </div>

        <!-- Yan Menü Üst Sekmeleri: Modüller vs Mükellefler -->
        <div class="menu-tab-container">
          <ion-segment
            [value]="sideMenuTab()"
            (ionChange)="sideMenuTab.set($any($event).detail.value)"
            mode="md"
            class="menu-top-segment"
          >
            <ion-segment-button value="moduller">
              <ion-label>Modüller</ion-label>
            </ion-segment-button>
            <ion-segment-button value="mukellefler">
              <ion-label>Mükellefler</ion-label>
            </ion-segment-button>
          </ion-segment>
        </div>

        <!-- SEKME 1: MODÜLLER -->
        @if (sideMenuTab() === 'moduller') {
          <ion-list id="inbox-list">
            @for (p of appPages; track p.title) {
              <ion-menu-toggle auto-hide="false">
                <ion-item
                  button
                  lines="none"
                  detail="false"
                  [class.selected]="activePanel() === p.panel"
                  (click)="navigateToPanel(p.panel)"
                >
                  <ion-icon aria-hidden="true" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                  <ion-label>{{ p.title }}</ion-label>
                  @if (getBadgeCount(p.panel) !== null) {
                    <ion-badge slot="end" class="segment-count-badge" [color]="activePanel() === p.panel ? 'primary' : 'light'">
                      {{ getBadgeCount(p.panel) }}
                    </ion-badge>
                  }
                </ion-item>
              </ion-menu-toggle>
            }

            @if (auth.isAuthenticated()) {
              <div class="user-profile-menu-box">
                <div class="user-info-card">
                  <div class="user-avatar-circle">
                    <ion-icon name="person-circle-outline"></ion-icon>
                  </div>
                  <div class="user-info-text">
                    <span class="user-name">{{ auth.currentUser()?.organization || auth.currentUser()?.name || 'Kullanıcı' }}</span>
                    <span class="user-phone">{{ auth.currentUser()?.phone }}</span>
                  </div>
                </div>

                <!-- EKRAN SEÇİM (Basit, Kullanıcı, Yönetim) -->
                <div class="view-mode-selector-wrapper">
                  <span class="view-mode-label">Ekran Seçim:</span>
                  <div class="view-mode-pill-group">
                    <button
                      type="button"
                      class="view-pill-btn"
                      [class.active]="db.appViewMode() === 'basit'"
                      (click)="db.setViewMode('basit')"
                    >
                      Basit
                    </button>
                    <button
                      type="button"
                      class="view-pill-btn"
                      [class.active]="db.appViewMode() === 'standart'"
                      (click)="db.setViewMode('standart')"
                    >
                      Kullanıcı
                    </button>
                    <button
                      type="button"
                      class="view-pill-btn"
                      [class.active]="db.appViewMode() === 'gelismis'"
                      (click)="db.setViewMode('gelismis')"
                    >
                      Yönetim
                    </button>
                  </div>
                </div>

                <ion-menu-toggle auto-hide="false">
                  <button type="button" class="logout-btn-action" (click)="auth.logout()">
                    <ion-icon name="log-out-outline"></ion-icon>
                    <span>Çıkış Yap</span>
                  </button>
                </ion-menu-toggle>
              </div>
            } @else {
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/login" lines="none" detail="false" class="login-menu-item">
                  <ion-icon aria-hidden="true" slot="start" ios="log-in-outline" md="log-in-sharp"></ion-icon>
                  <ion-label>Giriş Yap</ion-label>
                </ion-item>
              </ion-menu-toggle>
            }
          </ion-list>
        }

        <!-- SEKME 2: MÜKELLEFLER -->
        @if (sideMenuTab() === 'mukellefler') {
          <div class="mukellef-section">
            <div class="mukellef-search-box">
              <ion-searchbar
                [value]="mukellefSearch()"
                (ionInput)="mukellefSearch.set($any($event).detail.value || '')"
                placeholder="Mükellef ara (Ad, VKN, Tel)..."
                mode="ios"
                class="mukellef-searchbar"
              ></ion-searchbar>
            </div>

            <ion-list id="mukellef-list">
              <ion-list-header>
                Kayıtlı Mükellefler ({{ filteredMukellefler().length }})
              </ion-list-header>

              @for (m of filteredMukellefler(); track m.vkn) {
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    button
                    lines="full"
                    class="mukellef-item"
                    [class.active-mukellef]="db.currentVkn() === m.vkn"
                    (click)="selectMukellef(m)"
                  >
                    <ion-icon
                      slot="start"
                      ios="business-outline"
                      md="business-sharp"
                      [color]="db.currentVkn() === m.vkn ? 'primary' : 'medium'"
                    ></ion-icon>
                    <ion-label class="mukellef-label">
                      <!-- Line 1: 'Mükellef name' -->
                      <h3 class="mukellef-name">{{ m.name }}</h3>
                      <!-- Line 2: VKN, phone -->
                      <p class="mukellef-meta">
                        <span class="meta-vkn">VKN: {{ m.vkn }}</span>
                        <span class="meta-separator">•</span>
                        <span class="meta-phone">{{ m.phone }}</span>
                      </p>
                    </ion-label>
                    @if (db.currentVkn() === m.vkn) {
                      <ion-badge slot="end" color="primary" class="active-badge">Aktif</ion-badge>
                    }
                  </ion-item>
                </ion-menu-toggle>
              } @empty {
                <div class="empty-mukellef-msg">
                  <p>Arama kriterine uygun mükellef bulunamadı.</p>
                </div>
              }
            </ion-list>
          </div>
        }
      </ion-content>
      </ion-menu>
    }
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
